import React from 'react';
import { Box, Table, Thead, Tr, Td, Th, Tbody, Text } from '@chakra-ui/react';
import FeatureDot from './FeatureCheckbox';
import TableKey from './TableKey';

const CELL_PADDING = ['3', '5', '8'];

interface FeatureTableProps {
  headers: { title: string; description: string }[];
  rows: { title: string; availableInRoofOnly: boolean }[];
}

const FeatureTable = ({ headers = [], rows = [] }: FeatureTableProps) => (
  <Box mx={5} my={12}>
    <TableKey />
    <Table bgColor="#f5fafe">
      <Thead>
        <Tr bg="black">
          {headers.map(header => (
            <Th key={header.title} color="white" p={CELL_PADDING}>
              <Text fontSize={['xs', 'lg']} my={2}>
                {header.title}
              </Text>
              <Text fontSize={['xx-small', 'sm']} my={2}>
                {header.description}
              </Text>
            </Th>
          ))}
        </Tr>
      </Thead>
      <Tbody>
        {rows.map(row => (
          <Tr borderColor="gray.600" key={row.title} fontSize={['xs', 'lg']}>
            <Td p={CELL_PADDING}>{row.title}</Td>
            <Td p={CELL_PADDING}>
              <FeatureDot
                key={row.title}
                isSelected={row.availableInRoofOnly}
              />
            </Td>
            <Td p={CELL_PADDING}>
              <FeatureDot isSelected />
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  </Box>
);

export default FeatureTable;
